import styles from "./QuestName.module.css";

type QuestNameProps = {
  title: string | null;
  assignment: string | null;
};

// The assignment leads: the title is the template's and reads identically on
// every rung, so a list showing the label alone would repeat one row six
// times. The title stays above it as a kicker, naming which ladder this is.
export const QuestName = ({ title, assignment }: QuestNameProps) => (
  <div className={styles.name}>
    <span className={styles.title}>{title ?? "—"}</span>
    {assignment === null ? null : (
      <span className={styles.assignment}>{assignment}</span>
    )}
  </div>
);
